module.exports = __webpack_public_path__ + "img/parkStyleSwiper.43d89479.png";